
class TemplateItemMapper {
	constructor(selector, executeFunction) {
		this.selector = selector;
		this.executeFunction = executeFunction;
	}

	selector = '';
	executeFunction = function (object, context) {
	}
}

class RemoveTemplateItemMapper extends TemplateItemMapper {
	constructor(selector, shouldRemove) {		

		let execFunction = (obj, context) => {
			obj.each((i, objItem) => {
				objItem = $(objItem);

				if(shouldRemove){
					objItem.remove();
				}
			});
		}

		super(selector, execFunction);
	}
}
class DefaultTemplateItemMapper extends TemplateItemMapper {
	constructor(additionalExec) {
		let selector = '[data-id]';
		let execFunction = (obj, context) => {
			obj.each((_, objItem) => {
				objItem = $(objItem);
				objItem.attr("id", objItem.data('id') + context.mainId);

				if (typeof (additionalExec) === "function") {
					additionalExec(objItem);
				}
			});
		}
		super(selector, execFunction);
	}
}

class TemplateMapper {

	executeLayout(templateObject, formatterOptions) {
		let clonedTemplate = templateObject.clone(true);
		let {templateMappings, context} = formatterOptions;

		if (Array.isArray(templateMappings) && templateMappings[0] instanceof TemplateItemMapper) {
			for (let templateMapping of templateMappings) {
				let foundObject = clonedTemplate.find(templateMapping.selector).addBack(templateMapping.selector);

				if (foundObject.length > 0) {
					templateMapping.executeFunction(foundObject, context);
				}
			}
		}
		return clonedTemplate;
	}
}


export {TemplateItemMapper, TemplateMapper, DefaultTemplateItemMapper, RemoveTemplateItemMapper}